// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__YEhdy","header":"ReportDetails_header__2QlQl","title":"ReportDetails_title__3Uh6c","left":"ReportDetails_left__2Rkyt"};